// https://gist.github.com/andywer/800f3f25ce3698e8f8b5f1e79fed5c9c
import * as React from 'react';
import { manageSiteVersion } from 'utilities/fetch/version-request.js';

type ErrorHandler = (error: Error, info: React.ErrorInfo) => void;
type ErrorHandlingComponent<Props> = (props: Props, error?: Error) => React.ReactNode;

type ErrorState = { error?: Error };

export function Catch<Props>(
  component: ErrorHandlingComponent<Props>,
  errorHandler?: ErrorHandler,
): React.ComponentType<Props> {
  return class ErrorBoundary extends React.Component<Props, ErrorState> {
    override state: ErrorState = {
      error: undefined,
    };

    static getDerivedStateFromError(error: Error) {
      return { error };
    }

    override componentDidCatch(error: Error, info: React.ErrorInfo) {
      const isChunkError = error instanceof Error && error.name === 'ChunkLoadError';
      if (isChunkError) {
        // Reload the page on next render
        manageSiteVersion(__VERSION__, true);
      }
      if (errorHandler) {
        errorHandler(error, info);
      }
    }

    override render() {
      return component(this.props, this.state.error);
    }
  };
}
